import './student-parent-mapping.scss';
import homeTpl from './views/student-parent-mapping.html';
import homeCtrl from './controllers/mappingController';
var module = angular.module('studentParentMapping', [
    //import modules
])
.controller('studentParentMapping', homeCtrl);





// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentParentMapping', {
//             parent: 'app',
//             url: '/studentParentMapping',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'studentParentMapping'
//                 }
//             }
//         })

// });



// WEBPACK FOOTER //
// ./src/app/student_mapping/mappingModule.js